<div *ngIf="galleries" class="wrapper classPadding">
    <app-gallery-grid
        *ngIf="galleries.length > 0; else noGalleries"
        [galleries]="galleries">
    </app-gallery-grid>

    <ng-template #noGalleries>
        <div class="no-galleries">
            <div class=>
                <div class="hint">
                    <div class="imageClass w-[312px] xl:h-[312px] hidden md:block">
                        <img src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myGalleries/emptyStatus.png" alt="Image not available" class="size-full object-cover">
                    </div>
                    <div class="sectionRight">
                        <div class="columnContent title">
                            <span class="typography-title-l classTitle primaryDefault-color">
                                {{ 'my-galleries.no-galleries' | translate }}
                            </span>
                        </div>
                        <div class="columnContent body mb-8">
                          <p class="typography-body-m-regular mt-0 mb-4">{{ 'my-galleries.content-no-galleries-l1' | translate }}</p>
                          <ul class="typography-body-m-regular my-0">
                            <li class="mb-4" [innerHTML]="'my-galleries.content-no-galleries-l2' | translate"></li>
                            <li>
                              {{ 'my-galleries.content-no-galleries-l3' | translate }}
                            </li>
                          </ul>
                        </div>
                        <div class="w-full lg:w-auto">
                            <app-button class="w-full lg:w-auto" skin="we" [showIcon]="true" iconPosition="end" iconType="add" [primary]="true" [gtmLabel]="'first-gallery_button_add-new-gallery'" (onClick)="onNavigate()" size="large" >
                                <span class="typography-body-m-medium oneLine">
                                    {{ 'my_galleries.mygalleriesnew2_add_new_gallery' | translate }}
                                </span>
                            </app-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>

